import {useModals} from "@mantine/modals";
import {useNavigate} from "react-router-dom";
import React from "react";
import EditBunkerRequestForm from "../../components/forms/bunkerRequest/EditBunkerRequestForm";

export default function useEditBunkerRequest(navigateAway: boolean = false) {
    const modals = useModals();
    const navigate = useNavigate();

    const openModal = (id: string) => {
        const modalId = modals.openModal({
            size: "xl",
            title: 'Edit bunker request',
            closeOnClickOutside: false,
            children: (
                <>
                    <EditBunkerRequestForm bunkerRequestId={id} onClose={() => closeModal(modalId)}/>
                </>
            ),
        });
    };

    const closeModal = (id: string) => {
        modals.closeModal(id)
        navigateAway && navigate("/requests")
    }

    return {
        openModal
    }
}
